<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table scrollable-table">
  <ng-container matColumnDef="securedCardNumber">
    <th mat-header-cell *matHeaderCellDef> Credit Card nummer </th>
    <td mat-cell *matCellDef="let data"> {{data.securedCardNumber ? data.securedCardNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{data.status ? data.status : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="validUntil">
    <th mat-header-cell *matHeaderCellDef> Geldig t/m </th>
    <td mat-cell *matCellDef="let data"> {{data.validUntil ? data.validUntil : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="creationDate">
    <th mat-header-cell *matHeaderCellDef> Datum aanvraag </th>
    <td mat-cell *matCellDef="let data"> {{data.creationDate ? data.creationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="notificationPassFactoryDate">
    <th mat-header-cell *matHeaderCellDef> Datum uitgifte </th>
    <td mat-cell *matCellDef="let data"> {{data.notificationPassFactoryDate ? data.notificationPassFactoryDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="cancellationDate">
    <th mat-header-cell *matHeaderCellDef> Datum vervallen </th>
    <td mat-cell *matCellDef="let data"> {{data.cancellationDate ? data.cancellationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="replacementDate">
    <th mat-header-cell *matHeaderCellDef> Datum vervangen </th>
    <td mat-cell *matCellDef="let data"> {{data.replacementDate ? data.replacementDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="blocked">
    <th mat-header-cell *matHeaderCellDef> Geblokkeerd </th>
    <td mat-cell *matCellDef="let data"> {{data.blocked ? 'Ja' : 'Nee'}} </td>
  </ng-container>

  <ng-container matColumnDef="blockReason">
    <th mat-header-cell *matHeaderCellDef> Reden blokkering </th>
    <td mat-cell *matCellDef="let data"> {{data.blockReason ? data.blockReason : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="unblockPermitted">
    <th mat-header-cell *matHeaderCellDef> Handm. Deblokk. Mogelijk? </th>
    <td mat-cell *matCellDef="let data"> {{data.unblockPermitted ? 'Ja' : 'Nee'}} </td>
  </ng-container>

  <ng-container matColumnDef="requestReason">
    <th mat-header-cell *matHeaderCellDef> Reden bestelling </th>
    <td mat-cell *matCellDef="let data"> {{data.requestReason ? data.requestReason : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>

</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
